export const colors = {
    "mainBlue": "#70C2BBFF",
    "mainGreen": "#92BD11FF",
    "mainDarkBlue": "#2F4145FF",
    'secondBeige': "#D6CBBAFF",
    'secondBlue': "#CDE4F4FF"
}